<!-- Filters span the row: the selects share the width rather than bunching on the right. -->
<div class="row g-2 mb-2 align-items-center">
  <div class="col-12 col-md-6 col-lg-2">
    <ng-select
      placeholder="Product"
      [items]="products"
      [clearable]="true"
      [searchable]="true"
      [(ngModel)]="filters.product"
      (change)="onFilterChange()"
      bindLabel="name"
      bindValue="id" />
  </div>

  <div class="col-12 col-md-6 col-lg-2">
    <ng-select
      placeholder="Company"
      [items]="companies"
      [clearable]="true"
      [searchable]="true"
      [(ngModel)]="filters.company"
      (change)="onFilterChange()"
      bindLabel="name"
      bindValue="id" />
  </div>

  <div class="col-12 col-md-6 col-lg-2">
    <ng-select
      placeholder="Dealer"
      [items]="dealers"
      [clearable]="true"
      [searchable]="true"
      [(ngModel)]="filters.dealer"
      (change)="onFilterChange()"
      bindLabel="shop_name"
      bindValue="id" />
  </div>

  <div class="col-12 col-md-6 col-lg-2">
    <ng-select
      placeholder="Employee"
      [items]="employees"
      [clearable]="true"
      [searchable]="true"
      [(ngModel)]="filters.employee"
      (change)="onFilterChange()"
      bindLabel="full_name"
      bindValue="id" />
  </div>

  <div class="col-6 col-lg-2">
    <div class="input-group">
      <span class="input-group-text">From</span>
      <input
        type="date"
        class="form-control"
        [attr.max]="filters.to_date"
        [attr.title]="dateLabel + ' from'"
        [(ngModel)]="filters.from_date"
        (ngModelChange)="onFilterChange()" />
    </div>
  </div>

  <div class="col-6 col-lg-2">
    <div class="input-group">
      <span class="input-group-text">To</span>
      <input
        type="date"
        class="form-control"
        [attr.min]="filters.from_date"
        [attr.title]="dateLabel + ' to'"
        [(ngModel)]="filters.to_date"
        (ngModelChange)="onFilterChange()" />
    </div>
  </div>

  <!-- Section-specific controls (status select, export button) share the last cell. -->
  <div class="col-12 d-flex flex-wrap align-items-center justify-content-lg-end gap-2">
    <ng-content></ng-content>
  </div>
</div>

@if (isRangeReversed) {
  <p class="text-danger small mb-2">
    <i class="bi bi-exclamation-circle me-1"></i>
    From is after To, so the list is still showing the last range that made sense.
  </p>
}

@if (activeFilters.length) {
  <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
    <span class="text-muted small">
      {{ activeFilters.length }} {{ activeFilters.length === 1 ? 'filter' : 'filters' }} active:
    </span>

    @for (filter of activeFilters; track filter.key) {
      <span class="app-badge badge-soft-primary d-inline-flex align-items-center gap-1">
        <span class="text-muted">{{ filter.label }}:</span>
        {{ filter.value }}
        <button
          type="button"
          class="btn btn-link p-0 border-0 lh-1 text-reset"
          [attr.aria-label]="'Remove ' + filter.label + ' filter'"
          (click)="removeFilter(filter.key)">
          <i class="bi bi-x"></i>
        </button>
      </span>
    }

    <button type="button" class="btn btn-link btn-sm p-0 text-decoration-none" (click)="clearAll()">Clear all</button>
  </div>
}
